export default __webpack_public_path__ + "static/media/logo-text.a3db8335.png";